import React, { useState } from 'react';
import { useReactMediaRecorder } from 'react-media-recorder';
import MicIcon from '@material-ui/icons/Mic';
import { Button, Paper } from '@material-ui/core';
import StopIcon from '@material-ui/icons/Stop';
import { useEffect } from 'react';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { Label } from 'reactstrap';

let timerInterval;
let sentTimer;
const ReactMicComp = ({ error, passMedia }) => {
  const { status, startRecording, stopRecording, mediaBlobUrl, clearBlobUrl } = useReactMediaRecorder({ audio: true });
  const [counts, setCountDown] = useState(0);
  const [minutes, setMinute] = useState(0);

  const startTimer = () => {
    clearInterval(timerInterval);
    timerInterval = setInterval(() => {
      setCountDown(prevState => prevState + 1);
    }, 1000);
  };

  useEffect(() => {
    sentTimer = setTimeout(() => {
      passMedia(mediaBlobUrl);
    }, 1000);
    return () => clearTimeout(sentTimer);
  }, [mediaBlobUrl]);

  useEffect(() => {
    if (counts !== 0 && counts % 60 === 0) {
      setMinute(minutes + Math.trunc(counts / 60));
      setCountDown(0);
    }
  }, [counts]);

  const handleStartClick = () => {
    clearBlobUrl();
    setCountDown(0);
    setMinute(0);
    startTimer();
    startRecording();
  };

  const handleStopClick = () => {
    clearInterval(timerInterval);
    stopRecording();
  };

  const getStatusLabel = () => {
    const statusList = {
      recording: 'Recording',
      stopped: 'Stopped',
    };
    return statusList[status] || '';
  };

  return (
    <>
      <Label>
        Voice Call or Message <sup>*</sup>
      </Label>
      <Paper variant="outlined" style={{ padding: 10 }}>
        {getStatusLabel() && (
          <>
            <FiberManualRecordIcon style={{ color: status === 'recording' ? 'green' : 'red' }} /> {getStatusLabel()}
          </>
        )}
        <div style={{ textAlign: 'center' }}>
          <audio src={mediaBlobUrl} controls />
          <br />
          <div>
            <br />
            <div>
              {minutes?.toString().padStart(2, 0)} : {counts?.toString().padStart(2, 0)}
            </div>
            <br />
            {status !== 'recording' ? (
              <Button variant="contained" color="secondary" onClick={handleStartClick}>
                <MicIcon />
              </Button>
            ) : (
              <Button variant="contained" color="secondary" onClick={handleStopClick}>
                <StopIcon />
              </Button>
            )}
          </div>
        </div>
      </Paper>
      {error && <span className="err-msg">{error}</span>}
    </>
  );
};

export default ReactMicComp;
